import React from "react";
import { CircularsContainer } from "./style";
import { Container } from "react-bootstrap";
const Circulars = () => {
  return (
    <CircularsContainer>
      <Container>
        <div className="items">

            <a
                href="./pdf/14050623.pdf"
                target="_blank"
                className="item"
            >
                بخشنامه فروش فوری خودرو یونی‌تی - شهریور ۱۴۰۵

            </a>
        </div>
      </Container>
    </CircularsContainer>
  );
};
export default Circulars;
